var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{staticClass:"oct-icon",class:[
    `oct-icon__${_vm.icon}`,
    {
      'oct-icon--active': _vm.active
    }
  ],attrs:{"viewBox":`0 0 ${_vm.width} ${_vm.height}`}},[_c('use',{attrs:{"xlink:href":`#oct-icon__${_vm.icon}`}})])
}
var staticRenderFns = []

export { render, staticRenderFns }